// src/pages/Account/SafesList.jsx
import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

export default function SafesList() {
  const navigate = useNavigate();
  const branchId = parseInt(localStorage.getItem('branchId'), 10);
const companyId = parseInt(localStorage.getItem('companyId'), 10);

  const [safes, setSafes] = useState([]);

  const fetchSafes = () => {
    axios
      .get(`/Safe/by-company/${companyId}`)
      .then(res => setSafes(res.data))
      .catch(err => {
        console.error('❌ fetchSafes error:', err);
        setSafes([]);
      });
  };

  useEffect(() => {
    fetchSafes();
  }, [branchId]);

  const handleDelete = id => {
    if (window.confirm('هل أنت متأكد من حذف هذا الصندوق؟')) {
      axios
        .delete(`/Safe/${id}`)
        .then(fetchSafes)
        .catch(err => {
          console.error('❌ deleteSafe error:', err);
          alert('❌ حدث خطأ أثناء الحذف');
        });
    }
  };

  return (
    <Card className="max-w-4xl mx-auto mt-10" dir="rtl">
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">قائمة الصناديق</h2>
          <Button onClick={() => navigate('/safes/new')}>➕ صندوق جديد</Button>
        </div>

        <table className="w-full table-auto text-sm border-collapse">
          <thead>
            <tr className="bg-gray-100">
              {['#', 'الاسم', 'شركة', 'فرع', 'حالة', 'افتراضي', 'إجراءات'].map((h, i) => (
                <th key={i} className="px-2 py-1 border text-center">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {safes.length ? (
              safes.map((s, i) => (
                <tr key={s.safeId} className="even:bg-gray-50">
                  <td className="px-2 py-1 border text-center">{i + 1}</td>
                  <td className="px-2 py-1 border">{s.name}</td>
                  <td className="px-2 py-1 border">{s.companyName}</td>
                  <td className="px-2 py-1 border">{s.branchName}</td>
                  <td className="px-2 py-1 border text-center">
                    {s.status ? '✔️' : '—'}
                  </td>
                  <td className="px-2 py-1 border text-center">
                    {s.isDefault ? '✔️' : '—'}
                  </td>                  
                  <td className="px-2 py-1 border text-center space-x-1 space-x-reverse">
                    <Button size="icon" onClick={() => navigate(`/safes/${s.safeId}`)}>
                      ✏️
                    </Button>
                    <Button
                      size="icon"
                      variant="outline"
                      onClick={() => handleDelete(s.safeId)}
                    >
                      🗑️
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="py-4 text-center text-gray-500">
                  لا توجد بيانات
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
